// GlobalAnnouncement.tsx
import React from "react";
import { useAnnouncementContext } from "../../context/AnnouncementContext";
import AnnouncementToast from "./AnnouncementToast";

const GlobalAnnouncement: React.FC = () => {
  const { announcement, closeAnnouncement } = useAnnouncementContext();

  if (!announcement) return null;

  return (
    <AnnouncementToast
      type={announcement.type}
      message={announcement.message}
      onClose={closeAnnouncement}
    />
  );
};

export default GlobalAnnouncement;
